import { TitleGreenSpanFirst } from "@components/title/title-green-span-first";
import { PagePropsBasicType } from "../../../../@types/types-body";
import { FC } from "react";
import {BoxVideoFirstImage} from "@components/boxes/box-imavideoge-first-image";
const MobileWhatIsMobile: FC<PagePropsBasicType> = ({ namespace }) => {
  return (
    <section className="my-12" id="section-mobile-app">
        <TitleGreenSpanFirst
          id="section-what-is-mobile-app-title"
          namespace={namespace}
          title="section_what_is.title"
          span="section_what_is.span"
          description="section_what_is.description"
        />
        <BoxVideoFirstImage
          namespace={namespace}
          key={"section-mobile-app-intro"}
          object={"section_what_is.text"}
          image={"/images/services/animations/mobile.webm"}
          section={"section_what_is.title"}
        />
    </section>
  );
};

export default MobileWhatIsMobile;
